import {Customer} from '@hconnect/apiclient'
import {LabelRegular, TextMedium} from '@hm/fundamental'
import {CircularProgress} from '@material-ui/core'
import {AxiosError} from 'axios'
import React from 'react'

import {useTranslation} from '../../hooks/useTranslation'

type RoleCustomerChipProps = {
  customer?: Customer
  isCustomerLoading: boolean
  isError: boolean
  error: AxiosError
}

export const RoleCustomerChip = ({
  customer,
  isCustomerLoading,
  isError,
  error
}: RoleCustomerChipProps) => {
  const {t} = useTranslation()
  if (isCustomerLoading) {
    return <CircularProgress size={20} />
  }

  if (isError) {
    return (
      <div className="flex flex-col items-start">
        <TextMedium className="text-foreground">{customer?.customerId}</TextMedium>
        <TextMedium className="text-foreground">{t('manageUser.customer.error')}</TextMedium>
        <TextMedium className="text-foreground">{error.message}</TextMedium>
      </div>
    )
  }

  return (
    <div data-test-id="manageUser.customer" className="flex flex-col items-start">
      <LabelRegular className="text-foreground_faded">
        {t('manageUser.customer.title')}
      </LabelRegular>
      <TextMedium className="text-foreground">{customer?.customerName}</TextMedium>
      <LabelRegular className="text-foreground_faded">{customer?.customerNumber}</LabelRegular>
    </div>
  )
}
